var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "evalInfo",
          staticClass: "demo-ruleForm",
          attrs: { model: _vm.evalInfo, rules: _vm.rules }
        },
        [
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [_vm._v("商品满意度")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value width-1-5x mt10" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "score" } },
                  [
                    _c("el-rate", {
                      model: {
                        value: _vm.evalInfo.score,
                        callback: function($$v) {
                          _vm.$set(_vm.evalInfo, "score", $$v)
                        },
                        expression: "evalInfo.score"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("买家印象")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value width-1-5x" }, [
              _c(
                "ul",
                { staticClass: "enum-list clearfix" },
                _vm._l(_vm.tags, function(item) {
                  return _c(
                    "li",
                    {
                      class: _vm.checkedselect(item.id)
                        ? "enum-item checked"
                        : "enum-item",
                      on: {
                        click: function($event) {
                          _vm.select(item)
                        }
                      }
                    },
                    [_vm._v(_vm._s(item.name)), _c("i")]
                  )
                })
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("买家心得")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value width-1-5x" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "comment" } },
                  [
                    _c("el-input", {
                      attrs: { type: "textarea" },
                      model: {
                        value: _vm.evalInfo.comment,
                        callback: function($$v) {
                          _vm.$set(_vm.evalInfo, "comment", $$v)
                        },
                        expression: "evalInfo.comment"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "form-info" }, [
        _c(
          "div",
          {
            staticClass: "form-row",
            staticStyle: { overflow: "hidden", height: "auto" }
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "form-value width-3x" }, [
              _c(
                "div",
                { staticClass: "mt5" },
                [
                  _c("swb-file-upload", {
                    attrs: {
                      fileFor: "solution",
                      fileGroup: "file-misc",
                      onBeforeUpload: _vm.onBeforeUpload,
                      onProgress: _vm.onProgress,
                      onDone: _vm.onUploadDone,
                      multipleFile: true
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "file-area clearfix" },
                    _vm._l(_vm.evalFileList, function(evalFile, index) {
                      return _c("div", { staticClass: "mr15 inline-block" }, [
                        evalFile.fileExtName == "jpg" ||
                        evalFile.fileExtName == "png" ||
                        evalFile.fileExtName == "jpeg" ||
                        evalFile.fileExtName == "JPEG"
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "file-item show-usage image deletable viewable downloadable editable"
                              },
                              [
                                _c("div", { staticClass: "file-content" }, [
                                  _c(
                                    "div",
                                    { staticClass: "usage ellipsis-1" },
                                    [_vm._v(_vm._s(evalFile.fileName))]
                                  ),
                                  _vm._v(" "),
                                  _c("img", {
                                    attrs: { src: evalFile.fileBrowseUrl }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "operation-group" },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "icon iconfont icon-chakan view",
                                        on: {
                                          click: function($event) {
                                            _vm.viewImage(
                                              evalFile.fileBrowseUrl
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "delete-icon",
                                    on: {
                                      click: function($event) {
                                        _vm.removeUpload(index)
                                      }
                                    }
                                  })
                                ])
                              ]
                            )
                          : _c(
                              "div",
                              {
                                staticClass:
                                  "file-item show-usage deletable viewable downloadable editable"
                              },
                              [
                                _c("div", { staticClass: "file-content" }, [
                                  _c(
                                    "div",
                                    { staticClass: "usage ellipsis-1" },
                                    [_vm._v(_vm._s(evalFile.fileName))]
                                  ),
                                  _vm._v(" "),
                                  _c("img", {
                                    attrs: { src: evalFile.fileBrowseUrl }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "operation-group" },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "icon iconfont icon-xiazai download",
                                        on: {
                                          click: function($event) {
                                            _vm.downloadFile(evalFile.fileUuid)
                                          }
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "delete-icon",
                                    on: {
                                      click: function($event) {
                                        _vm.removeUpload(index)
                                      }
                                    }
                                  })
                                ])
                              ]
                            )
                      ])
                    })
                  )
                ],
                1
              )
            ])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("上传图片")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3086f711", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3086f711","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/order/OrderGoodsEvalSave.vue
// module id = 2680
// module chunks = 0